import React from 'react';

function CompassMark({ size = 38 }) {
  const s = size;
  const stroke = '#1B5E3F';
  const cx = s / 2;
  const cy = s / 2;
  const r = s * 0.42;
  return (
    <svg width={s} height={s} viewBox={`0 0 ${s} ${s}`} aria-hidden="true" focusable="false">
      <circle cx={cx} cy={cy} r={r} stroke={stroke} strokeWidth={2} fill="transparent" />
      {/* North arrow */}
      <path
        d={`M ${cx} ${cy - r - 2} L ${cx - 6} ${cy - r + 8} L ${cx + 6} ${cy - r + 8} Z`}
        fill={stroke}
      />
      <text
        x={cx}
        y={cy + 7}
        textAnchor="middle"
        fontFamily="Arial, sans-serif"
        fontWeight="700"
        fontSize={Math.max(12, s * 0.42)}
        fill={stroke}
      >
        N
      </text>
    </svg>
  );
}

export default function BrandHeader({ subtitle, right }) {
  return (
    <div className="brandHeader">
      <div className="brandLeft">
        <div className="brandMark">
          <CompassMark />
        </div>
        <div>
          <div className="brandWordmark">
            <span className="brandWordmarkA">Accelerate</span>
            <span className="brandWordmarkN">North</span>
          </div>
          <div className="brandTagline">Digital Transformation for Mid-Market Companies</div>
        </div>
      </div>

      <div className="brandCenter">
        <div className="brandOneLiner">The workarounds became the system. Everyone knows something&apos;s broken. No one can find it. We find it.</div>
        {subtitle ? <div className="brandSubtitle">{subtitle}</div> : null}
      </div>

      <div className="brandRight">{right}</div>
    </div>
  );
}
